import WpClient from '#lib/wordpress/wp-client';

const wpService = new WpClient();

export default wpService;
